import script from "./BillAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./BillAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./BillAnalysis.vue?vue&type=style&index=0&id=5a70d835&lang=scss&scoped=true"
import "./BillAnalysis.vue?vue&type=style&index=1&id=5a70d835&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a70d835"]])

export default __exports__